<template>
	<div class="spectrum-background">
		<div id="nav">
			<router-link :to="{ name: 'register' }">Register</router-link> |
			<router-link :to="{ name: 'activate-account' }"
				>Activate Account</router-link
			>| <router-link :to="{ name: 'login' }">Login</router-link>|
			<router-link :to="{ name: 'index' }">Home</router-link>|
			<router-link
				active-class="none"
				exact-active-class="none"
				:to="{ name: 'logout' }"
				>Logout</router-link
			>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	mounted() {
		if (this.$store.state.MY_PROFILE.name) {
			this.$router.push({ name: "index" })
		}
	}
}
</script>

<style>
/* .spectrum-background {
	background: linear-gradient(#53090e, transparent),
		linear-gradient(to top left, #112661, transparent),
		linear-gradient(to top right, #2a4c69, transparent);
	/* linear-gradient(to bottom right, #362eb8, transparent); */
/* background-blend-mode: screen; */
/* } */
</style>
